// extracted by mini-css-extract-plugin
export default {"AccordionInputItem":"AccordionInputItem_AccordionInputItem__4Ay47"};